import React from "react";
import { useSelector } from "react-redux";
import { selectJobDetailsSection, selectGeneralStation } from "../../../redux/selectors";

const PrintEnclosure = () => {
  const enclosureDetails = useSelector((state) =>
    selectJobDetailsSection(state, "stationEnclosure")
  );
  const generalSpecsDetails = useSelector(selectGeneralStation);
  const activetab = useSelector((state) => state.activeMechanicalTab.selectedZone);

  const stationColor = generalSpecsDetails.find((detail) => detail.Zone === activetab)?.Color || "";

  const isZoneEmpty = (detail) => {
    return (
      !detail.EnclosureType &&
      !detail.AcousticInsulation &&
      !detail.ExteriorLighting &&
      !detail.SnowWindRating &&
      !detail.SpecialHeight &&
      !detail.BaseLength &&
      !detail.EnclosurePaintColor &&
      !detail.ThermalInsulation &&
      !detail.InteriorLighting &&
      !detail.CoolingFans &&
      !detail.ExternalPowerConnection &&
      !detail.BaseWidth &&
      !detail.StationEnclosureComments
    );
  };

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    return (
      <div>
        {details
          .filter((detail) => detail && detail.HasEnclosure && Object.keys(detail).length > 0)
          .map((detail, index) => {
            if (isZoneEmpty(detail)) {
              return null;
            }
            return (
              <div className="section" key={index}>
                <table className="table table-bordered full-width">
                  <tbody>
                    <h3 className="print-zone-label">Zone: {detail.Zone}</h3>
                    <tr>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr><td><strong>Enclosure Type: </strong>{detail.EnclosureType}</td></tr>
                            <tr><td><strong>Acoustic Insulation: </strong>{detail.AcousticInsulation}</td></tr>
                            <tr><td><strong>Exterior Lighting: </strong>{detail.ExteriorLighting}</td></tr>
                            <tr><td><strong>Snow Wind Rating: </strong>{detail.SnowWindRating}</td></tr>
                            <tr><td><strong>Special Height: </strong>{detail.SpecialHeight}</td></tr>
                            <tr><td><strong>Base Length: </strong>{detail.BaseLength}</td></tr>
                          </tbody>
                        </table>
                      </td>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <strong>Enclosure Paint Color: </strong>
                                {detail.EnclosurePaintColor === "Same as Station" ? `Same as Station (${stationColor})` : detail.EnclosurePaintColor}
                              </td>
                            </tr>
                            <tr><td><strong>Thermal Insulation: </strong>{detail.ThermalInsulation}</td></tr>
                            <tr><td><strong>Interior Lighting: </strong>{detail.InteriorLighting}</td></tr>
                            <tr><td><strong>Cooling Fans: </strong>{detail.CoolingFans}</td></tr>
                            <tr><td><strong>External Power Connection: </strong>{detail.ExternalPowerConnection}</td></tr>
                            <tr><td><strong>Base Width: </strong>{detail.BaseWidth}</td></tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p><strong>Comments:</strong><br />{detail.StationEnclosureComments}</p>
                <br className="clearfix" />
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div>
      {enclosureDetails && enclosureDetails.some(detail => detail.HasEnclosure) && <h2 className="print-section-header">Station Enclosure Summary</h2>}
      {renderDetails(enclosureDetails)}
    </div>
  );
};

export default PrintEnclosure;
